<template>
  <div class="footer container-fluid">
    <div class="row d-flex flex-row justify-contentet-around p-2">
      <div class="col-4">
        <Texto :esHome="esHome" :index="0" :route="route[0]" />
      </div>
      <div class="col-4">
        <Texto :esHome="esHome" :index="1" :route="route[1]" />
      </div>
      <div class="col-4">
        <Texto :esHome="esHome" :index="2" :route="route[2]" />
      </div>
    </div>
  </div>
</template>

<script>
import Texto from '@/components/atomos/Texto.vue'

export default {
  name: 'Footer',
  components: { Texto },
  props: {
    esHome: Boolean
  },
  data() {
    return {
      contents: [],
      route: []
    }
  },

  created() {
    // let obj = {}
    for (let index = 0; index < 3; index++) {
      let obj = {}
      obj.name = 'footer'
      obj.index = index
      this.route.push(obj)
      // console.log(this.$props)
    }
    // console.log(this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid])
  }
}
</script>

<style scoped>
.footer {
  background-color: #f0f0f0;
  min-height: 155px;
}
ul {
  list-style: none;
}
</style>
